import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Router } from '@angular/router';
import { Observable } from 'rxjs-compat/Observable'
import { LabApiConfiguration } from '../apiConfiguration';
import { ResultFormulaTest } from '../../../models/lab/resultFormulaTest';
import { ServiceBase } from 'app/shared/infrastructure';

@Injectable()
export class ResultFormulaTestsService extends ServiceBase {

    private _actionUrl: string;
    private _url: string;

    constructor(private _http: HttpClient, private _configuration: LabApiConfiguration, private _router: Router) {
        super();
        this._actionUrl = _configuration.server;
        this._url = this._actionUrl + _configuration.resultFormulaTest.url;
    }

    get = (): Observable<any> => {
        return this._http.get<any>(this._url);
    }

    getById = (id): Observable<ResultFormulaTest> => {
        const url = `${this._url}/${id}`;
        return this._http.get<any>(url)
    }

    add = (data: any) => {
        return this._http.post<any>(this._url, JSON.stringify(data));
    }

    put = (id: number, data: any) => {
        const url = `${this._url}/${id}`;
        return this._http.put<any>(url, JSON.stringify(data));
    }

    delete = (id: number) => {
        const url = `${this._url}/${id}`;
        return this._http.delete(url);
    }
}
